define('SearchSpring.TypeAhead.Model', [
    'SC.Configuration',
    'Profile.Model',
    'Backbone',
    'Backbone.CachedModel',
    'jQuery',
    'underscore'
], function FacetsSearchSpringTypeAheadModel(
    Configuration,
    ProfileModel,
    Backbone,
    CachedModel,
    jQuery,
    _
) {
    'use strict';

    var originalFetch = CachedModel.prototype.fetch;

    return CachedModel.extend({
        urlRoot: Configuration.get('searchspring.autocompleteUrl').split('[SITEID]').join(Configuration.get('searchspring.siteId')),
        fetch: function fetch(pOptions) {
            var options = pOptions || {};
            options.cache = true;

            return originalFetch.apply(this, arguments);
        },
        sync: function sync(method, collection, options) {
            var cachedModel;
            // This is a fix to not cancell the request if the new url is the same as a cached one that has not finished.
            var url = _.result(this, 'url');
            if (options && options.data) {
                url += ((url.indexOf('?') !== -1) ? '&' : '?') + jQuery.param(options.data);
            }

            cachedModel = Backbone.localCache[url];
            if (!!cachedModel && !cachedModel.status) {
                cachedModel.killerId = options.killerId;
            }

            options.dataType = 'jsonp';
            options.jsonpCallback = 'jsonpCallback' + Math.round(Math.random() * 100000);
            return CachedModel.prototype.sync.apply(this, arguments);
        },
        getFullTerm: function getFullTerm(pTerm, words, index) {
            var term = pTerm;
            var emElements;
            var firstTerm;
            if (index + 1 < words.length) {
                if (words[index + 1].indexOf('<em>') > -1) {
                    term += ' ' + words[index + 1];
                    term = term.replace('</em> <em>', ' ');
                    term = this.getFullTerm(term, words, index + 1);
                    emElements = jQuery('<div>').html(term).find('em');
                    if (emElements.length > 1) {
                        firstTerm = jQuery('<div>').html(emElements.get(0));
                        term = term.replace(/<(?:.|\n)*?>/gm, '').replace(firstTerm.text(), firstTerm.html());
                    }
                }
            }
            return term;
        },
        parse: function parse(response) {
            var self = this;
            var term;
            var excludedFacets = Configuration.get('facetsExtra.exclude') || [];
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var facetData = Configuration.get('facets') || [];
            if (response.products && response.products.length) {
                _.each(response.products, function (product) {
                    var words = product.name.split(' ');
                    _.every(words, function (word, index) {
                        if (word.indexOf('<em>') > -1) {
                            term = self.getFullTerm(word, words, index);
                            if (term.replace(/<(?:.|\n)*?>/gm, '').toLowerCase() === response.query.toLowerCase()) {
                                response.terms.unshift(term);
                            } else {
                                response.terms.push(term);
                            }
                            return false;
                        }
                        return true;
                    });
                });
                response.terms = _.uniq(_.map(response.terms, function (aTerm) {
                    return aTerm.toLowerCase().replace('</em> <em>', ' ');
                }));

                response.facets = _.filter(response.facets, function filterFacets(f) {
                    var facetInfo = _.findWhere(facetData, { id: f.field });

                    return (!facetInfo || !facetInfo.storeId || !store || facetInfo.storeId + '' === store.get('internalid') + '')
                        && excludedFacets.indexOf(f.field) === -1;
                });
            }
            return response;
        }
    });
});
